import React from 'react';
import { getShowDocumentLink } from '../../../../../helper/uiFunctions';

const ProdPlanPopupOrderSheetData = ({ orderSheet }) => {
    if (!orderSheet) return null;

    const groupLabel = [
        orderSheet.osGroup || '',
        orderSheet.osLocation || ''
    ].filter(Boolean).join(' / ');

    const onOpenOrderSheet = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const documentLink = getShowDocumentLink(orderSheet.orderSheetTypeId, orderSheet.orderSheetId, '', 1, '', '');
        if (!documentLink) return;

        window.open(documentLink, '_blank');
    };

    return (
        <div className="uiProdGridProcessContainer">
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '12px',
                    flexWrap: 'wrap'
                }}
            >
                <button
                    type="button"
                    className="uiProdPlanPopupDocCodeLink uiLink"
                    onClick={onOpenOrderSheet}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        font: 'inherit',
                        textAlign: 'left'
                    }}
                >
                    <div className="uiTitle">
                        {orderSheet.orderSheetId || ''}
                    </div>
                </button>
                <div className="uiGrey uiUnHighlight">
                    {orderSheet.osDate || ''}
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: '12px'
                }}
            >
                <div style={{ minWidth: 0, flex: 1 }}>
                    <span className="uiBold">Location</span>
                    <span className="uiSpacerH5">{groupLabel}</span>
                </div>
                <div style={{ whiteSpace: 'nowrap' }}>
                    <span className="uiBold">Qty</span>
                    <span className="uiSpacerH5">{orderSheet.osQty || ''}</span>
                </div>
            </div>

            <div>
                <span className="uiBold">Comments</span>
                <span className="uiSpacerH5">{orderSheet.osComments || ''}</span>
            </div>
        </div>
    );
};

export default ProdPlanPopupOrderSheetData;
